module.exports = __webpack_public_path__ + "static/media/sign-out.c05aa1e2.svg";